/**
 * @ngdoc Filter
 * @name vrmDeviceIcon
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .filter('vrmDeviceIcon', vrmDeviceIcon);

    function vrmDeviceIcon() {
        return function(deviceType){
            switch(deviceType) {
                case 'battery':
                    return 'sg-vrm-icon_021_battery-16px';
                case 'solar':
                    return 'sg-vrm-icon_022_solar-16px';
                case 'grid':
                    return 'sg-vrm-icon_023_grid-16px';
                case 'generator':
                    return 'sg-vrm-icon_025_genset-16px';
            }
        }
    }

})();
